// knowledgeDetails.pipeline.chunk.* — owned by the chunk page.
export default {
  back: 'Back to documents',
  docSummary: '{{chunks}} chunks · {{tokens}} tokens',
  selected: '{{n}} of {{total}} selected',
  page: 'page {{page}}',
  pages: 'pages {{first}}–{{last}}',
  regions_one: '{{count}} region',
  regions_other: '{{count}} regions',
  image: 'image',
  none: 'none',
  weights: {
    label: 'Term-match weights',
    keywords: 'Keywords',
    questions: 'Questions',
    excluded: 'Excluded keywords',
    title: 'Title',
    titleHint:
      'The document title counts twice when a query is matched against this chunk.',
    keywordsHint:
      'Each keyword counts five times when a query is matched against this chunk.',
    questionsHint:
      'Each question counts six times in term matching, and questions steer the chunk embedding.',
    excludedHint:
      'This chunk is dropped from results whenever one of these words appears in the query.',
  },
  toolbar: {
    text: 'Text',
    show: 'Show',
    match: 'Match',
    fuzzy: 'Fuzzy',
    exact: 'Exact match',
    searchLabel: 'Search chunks',
  },
  list: {
    heading: 'Chunks {{from}}–{{to}}',
    caption_one:
      '{{count}} of {{total}} · every card shows its boosts and state',
    caption_other:
      '{{count}} of {{total}} · every card shows its boosts and state',
    selected: 'selected',
    open: 'Open',
    range: '{{from}}–{{to}} of {{total}}',
  },
  layout: {
    reset: 'Reset layout',
    collapse: 'Collapse {{panel}}',
    expand: 'Expand {{panel}}',
    panels: {
      list: 'chunk list',
      page: 'page panel',
      stages: 'stages',
      boosts: 'term-match boosts',
      preview: 'document preview',
    },
    showPreview: 'Show preview',
    previewTitle: 'Document preview',
    chunkNo: 'Chunk {{n}}',
    listLabel: 'Chunks on this page',
    enabled: 'Enabled',
    disabled: 'Disabled',
    select: 'Select chunk {{n}}',
    keys: '↑/↓ next chunk · Esc closes',
  },
  contentHint:
    'Click to inspect how this chunk was embedded; double-click to edit',
  frequentlyUsedHint:
    'Turns OFF every chunk of this document except those whose text contained **Frequently Used**: true.',
  inspector: {
    label: 'Chunk inspector',
    chunk: 'Chunk',
    chunks_one: '{{count}} chunk',
    chunks_other: '{{count}} chunks',
    tokens_one: '{{formatted}} token',
    tokens_other: '{{formatted}} tokens',
    contextualised: 'Contextualised',
    kind: {
      text: 'text chunk',
      image: 'image chunk',
      table: 'table chunk',
      other: '{{kind}} chunk',
    },
    testRetrieval: 'Test retrieval with this KB',
    test: 'Test',
    resizeTile:
      'Resize {{name}}: drag, or use the arrow keys; double-click or Home resets it',
    edit: 'Edit chunk',
    steer: 'Add a keyword/question to steer retrieval',
    contextualisedFact: 'contextualised {{value}}',
    yes: 'yes',
    no: 'no',
    cacheFact: 'cache {{strategy}}',
    created: 'created {{time}}',
    regionRow: '{{n}} · x {{x1}}–{{x2}} · y {{y1}}–{{y2}}',
    pagesScroll_one: 'Stored page of this chunk',
    pagesScroll_other: '{{count}} stored pages of this chunk',
    pagesScrollHint_other:
      '{{count}} pages · scroll inside the box to see each one',
    pagesScrollHint_one: '',
    regionLegend:
      'Dashed = region stored with the chunk. Clicking a region scrolls the preview to it; every region is listed here.',
    contextualisedChip: 'contextualised',
    enabled: 'enabled',
    disabled: 'disabled',
    heading: 'What was written → what was embedded',
    caption: 'the pipeline zoomed into one chunk',
    close: 'Close inspector',
    loading: 'Loading the stored chunk…',
    failed: 'Could not load the stored chunk.',
    steps: {
      original: 'Original content',
      contextualise: 'Contextualise',
      embed: 'Embed text',
      vector: 'Vector',
    },
    cache: 'cache',
    titleBlended: 'title blended at {{weight}}',
    dim: '{{dim}}-d',
    prefixAdded: 'prefix added',
    suffixAdded: 'appended',
    diff: {
      unchanged: 'The LLM added nothing; the chunk is embedded as written.',
      rewritten:
        'The LLM rewrote the chunk, so the original text no longer appears verbatim. Embed text shows the result.',
    },
    titleChip: 'title',
    originalView: 'Chunk Content view',
    summary: 'summary “{{summary}}”',
    concepts: 'key concepts: {{list}}',
    embedView:
      'Embed Content view · prefix + content, title blended at {{weight}}',
    vectorStored:
      'stored in the search index · model locked: {{count}} chunks embedded',
    vectorMissing: 'vector not returned',
    vectorAria: '{{dim}}-dimension vector drawn as {{count}} bucket averages',
    boosts: 'Term-match boosts',
    pageTitle: 'Page {{page}}',
    pageCaption:
      'regions stored with the chunk · click a region to open it in the preview',
    pageCaptionStatic: 'regions stored with the chunk',
    pageAria_one: 'Page {{page}} with {{count}} region of this chunk',
    pageAria_other: 'Page {{page}} with {{count}} regions of this chunk',
    openRegion: 'Open region {{n}} in the preview',
    imageTitle: 'Stored image',
    imageAlt: 'Image stored with this chunk',
    tabs: {
      inspector: 'Inspector',
      json: 'Chunk JSON',
    },
    autoKeywordOn:
      'Auto-keyword is on ({{configured}} per chunk): this chunk has {{count}} keywords, including any added by hand.',
    autoKeywordOff:
      'Auto-keyword is off. Turning it on adds LLM-generated keywords to every chunk.',
    autoKeywordLink: 'Turn it on in Configuration',
  },
};
